import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { NotificationModel } from './notification.model';
import { DatePipe } from '@angular/common';
import { faL } from '@fortawesome/free-solid-svg-icons';

@Injectable({
  providedIn: 'root'
})
export class AppService {

  dicprogram: any = {}
  programs: any[] = [];
  griddata: NotificationModel[] = [];
  serviceurl: string = '';
  programid: string = "";
  queryString: string = "";
  userid: string = "";
  


  constructor(private client: HttpClient, private datepipe: DatePipe) {

    this.userid = localStorage.getItem("loggedInUser") || '';
    const searchParams = new URLSearchParams(window.parent.location.search);
    this.programid = searchParams.get("programid") || '';
  }


  getNotifications() {

    let dd = this.datepipe.transform(new Date(), "yyyy-MM-dd");
    // this.serviceurl = "/SavedQueryService/Execute/portal-notifications/" + this.userid + "/" + this.programid;
    this.serviceurl = parent.window.location.href.toLowerCase().includes("notifications/home") ? "/SavedQueryService/Execute/portal-notifications-home/" + this.userid : "/SavedQueryService/Execute/portal-notifications/" + this.userid + "/" + this.programid;

    return new Observable<any>(subscriber => {

      this.client.get(this.serviceurl).subscribe((results: any) => {

        let ecrm_notificationids = "";
        // if(results.data.length > 0){

        //   ecrm_notificationids = results.data[0]["Attributes"]["contact.ecrm_notificationids"]["Value"] || "";

        // }

        results.data.forEach((ddetail: any) => {

          let rev: NotificationModel = {
          
            ecrm_ecrmid: ddetail.Attributes["ecrm_ecrmid"],
            ecrm_notificationid: ddetail.Attributes["ecrm_portalnotificationid"],
            ecrm_title: ddetail.Attributes["ecrm_title"] ? ddetail.Attributes["ecrm_title"] : null,
            ecrm_modifiedon: ddetail.FormattedValues["createdon"] ? ddetail.FormattedValues["createdon"] : null,
        
            ecrm_notificationtype: ddetail.Attributes["ecrm_notificationtype"] ? ddetail.Attributes["ecrm_notificationtype"] : null,
            ecrm_regarding: ddetail.Attributes["ecrm_regarding"] ? ddetail.Attributes["ecrm_regarding"] : null,
            ecrm_typeofchange: ddetail.Attributes["ecrm_typeofchange"] ? ddetail.Attributes["ecrm_typeofchange"] : null,
            ecrm_psid: ddetail.Attributes["ecrm_psid"] ? ddetail.Attributes["ecrm_psid"] : null,
            ecrm_oldvalue: ddetail.Attributes["ecrm_oldvalue"] ? ddetail.Attributes["ecrm_oldvalue"] : null,
            ecrm_newvalue: ddetail.Attributes["ecrm_newvalue"] ? ddetail.Attributes["ecrm_newvalue"] : null,
        
            ecrm_partnerowner: ddetail.Attributes["ecrm_partnerowner"] ? ddetail.Attributes["ecrm_partnerowner"] : null,
            ecrm_grant: ddetail.FormattedValues["ecrm_grant"] ? ddetail.FormattedValues["ecrm_grant"] : null,
            ecrm_program: ddetail.FormattedValues["ecrm_program"] ? ddetail.FormattedValues["ecrm_program"] : null,
            ecrm_partnership: ddetail.Attributes["ecrm_partnership"] ? ddetail.Attributes["ecrm_partnership"] : null,
            ecrm_contact: ddetail.Attributes["ecrm_contact"] ? ddetail.Attributes["ecrm_contact"] : null,
            ecrm_portallink: ddetail.Attributes["ecrm_portallink"] ? ddetail.Attributes["ecrm_portallink"] : null,
            isread : false

          }

          this.griddata.push(rev);

        });


        // this.griddata.forEach( (data) =>{

        //   if(ecrm_notificationids.includes(data.ecrm_ecrmid)){
        //     data.isread = true;
        //   }

        // })


        subscriber.next(this.griddata);
        subscriber.complete();


      }, error => {

        subscriber.error(error);
        subscriber.complete();
      })


    })


  }

  updateNotificationStatus() {


  }


}
